import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'secondsDuration'
})
export class DurationFormatPipe implements PipeTransform {
  private static readonly defaultSeparator = ':';

  transform(totalSeconds: number, separator?: string): string {
    separator = separator || DurationFormatPipe.defaultSeparator;
    const hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return hours + separator + minutes + separator + seconds;
  }
}
